// extracted by mini-css-extract-plugin
module.exports = {"timeLeftToPurchase":"TimeLeftToPurchase_timeLeftToPurchase__0qmy_"};